import React from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import logo from '../../assets/images/logo.png'
import { FaWhatsapp } from "react-icons/fa";
import { useLanguage } from '../../store/languageContext';
import { motion } from 'framer-motion'
import translate from '../../utils/translation';
const Navbar = () => {
    const [open, setOpen] = React.useState(false);
    const { language, toggleLanguage, navColor } = useLanguage();
    return (
        <motion.nav
            initial={{ y: -50, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.3, ease: 'easeOut' }}
            viewport={{ once: true }}
            className="fixed top-0 z-[100] w-full p-4" dir='ltr'>
            <div className="container mx-auto flex justify-between items-center">
                <div className='!min-w-[290px]'>
                    <div className={`w-fit border flex gap-1 items-center px-4 py-3 rounded-full filter-blur-8 duration-500 cursor-pointer ${navColor === 'black' ? 'text-black bg-white hover:text-white hover:bg-[#589EEE]' : 'text-white border-[#cccccc41] hover:bg-white hover:text-black'}`} onClick={() => toggleLanguage()}>
                        <span className={`duration-500 ${language === 'en' ? 'opacity-100' : 'opacity-50'} `}>
                            EN
                        </span>
                        <span className='opacity-50'>
                            /
                        </span>
                        <span className={`duration-500 ${language === 'ar' ? 'opacity-100' : 'opacity-50'} `}>
                            AR
                        </span>
                    </div>
                </div>
                <Link to="/" className="text-2xl font-bold chewy-regular flex items-center">
                    <img src={logo} alt="logo" className={`size-[64px] min-w-[64px] filter duration-500 brightness-0 ${navColor === 'black' ? '' : 'invert'}`} />
                </Link>
                <ul className={`!min-w-[290px] md:flex space-x-2 ${open ? 'block' : 'hidden'} md:bloc`}>
                    <li className={`border px-4 py-3 rounded-full filter-blur-8 duration-500 cursor-pointer ${navColor === 'black' ? 'text-black bg-white hover:text-white hover:bg-[#589EEE]' : 'text-white border-[#cccccc41] hover:text-black hover:bg-white'}`}><a className='flex gap-2 items-center' href="https://wa.me/+201117169426" target="_blank" rel="noopener noreferrer"><FaWhatsapp />{translate[language]['contactUs']}</a></li>
                    <li className={`border px-4 py-3 rounded-full filter-blur-8 duration-500 cursor-pointer ${navColor === 'black' ? 'text-black bg-white hover:text-white hover:bg-[#589EEE] ' : 'text-white border-[#cccccc41] hover:text-black hover:bg-white'}`}><Link to="/products">{translate[language]['products']}</Link></li>
                    {/* <li><Link to="/dashboard" className="hover:underline">Dashboard</Link></li> */}
                </ul>
                <button onClick={() => setOpen(!open)} className="md:hidden">
                    {open ? <X /> : <Menu />}
                </button>
            </div>
        </motion.nav>
    );
};

export { Navbar };